// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-card--reveal[data-v-ce4b7eaa]{align-items:center;bottom:0;justify-content:center;opacity:1;position:absolute;width:100%}.v-card__text[data-v-ce4b7eaa],.v-card__title[data-v-ce4b7eaa]{word-break:normal!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
